
      import API from "!../../../.yarn/__virtual__/style-loader-virtual-86d3e1e0ef/2/root/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../../.yarn/__virtual__/style-loader-virtual-86d3e1e0ef/2/root/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../../.yarn/__virtual__/style-loader-virtual-86d3e1e0ef/2/root/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../../.yarn/__virtual__/style-loader-virtual-86d3e1e0ef/2/root/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../../.yarn/__virtual__/style-loader-virtual-86d3e1e0ef/2/root/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../../.yarn/__virtual__/style-loader-virtual-86d3e1e0ef/2/root/.yarn/berry/cache/style-loader-npm-3.3.4-e2ff5c12be-10c0.zip/node_modules/style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../../.yarn/__virtual__/css-loader-virtual-7ec406d4a0/2/root/.yarn/berry/cache/css-loader-npm-6.11.0-d945f9f4c0-10c0.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../.yarn/__virtual__/postcss-loader-virtual-8ebf76a941/2/root/.yarn/berry/cache/postcss-loader-npm-6.2.1-45828eb0de-10c0.zip/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./BarcodeScannerDemo.css";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);


if (module.hot) {
  if (!content.locals || module.hot.invalidate) {
    var isEqualLocals = function isEqualLocals(a, b, isNamedExport) {
  if (!a && b || a && !b) {
    return false;
  }
  var p;
  for (p in a) {
    if (isNamedExport && p === "default") {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (a[p] !== b[p]) {
      return false;
    }
  }
  for (p in b) {
    if (isNamedExport && p === "default") {
      // eslint-disable-next-line no-continue
      continue;
    }
    if (!a[p]) {
      return false;
    }
  }
  return true;
};
    var isNamedExport = !content.locals;
    var oldLocals = isNamedExport ? namedExport : content.locals;

    module.hot.accept(
      "!!../../../.yarn/__virtual__/css-loader-virtual-7ec406d4a0/2/root/.yarn/berry/cache/css-loader-npm-6.11.0-d945f9f4c0-10c0.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../.yarn/__virtual__/postcss-loader-virtual-8ebf76a941/2/root/.yarn/berry/cache/postcss-loader-npm-6.2.1-45828eb0de-10c0.zip/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./BarcodeScannerDemo.css",
      function () {
        if (!isEqualLocals(oldLocals, isNamedExport ? namedExport : content.locals, isNamedExport)) {
                module.hot.invalidate();

                return;
              }

              oldLocals = isNamedExport ? namedExport : content.locals;

              update(content);
      }
    )
  }

  module.hot.dispose(function() {
    update();
  });
}


export * from "!!../../../.yarn/__virtual__/css-loader-virtual-7ec406d4a0/2/root/.yarn/berry/cache/css-loader-npm-6.11.0-d945f9f4c0-10c0.zip/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[1]!../../../.yarn/__virtual__/postcss-loader-virtual-8ebf76a941/2/root/.yarn/berry/cache/postcss-loader-npm-6.2.1-45828eb0de-10c0.zip/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[5].use[2]!./BarcodeScannerDemo.css";
       export default content && content.locals ? content.locals : undefined;
